import { GoogleMerchantSettingsFormFields, TGoogleMerchantSettingsFormValues } from './types';
import { IGoogleMerchantSettings } from '@/models/googleMerchantSettings.model';

export const getMerchantSettingsInitialValues = (
  merchantSettings: IGoogleMerchantSettings | null,
): Partial<TGoogleMerchantSettingsFormValues> => {
  return {
    [GoogleMerchantSettingsFormFields.ENABLED]: merchantSettings?.enabled,
    [GoogleMerchantSettingsFormFields.ACCOUNT_ID]: merchantSettings?.accountId || undefined,
    [GoogleMerchantSettingsFormFields.SEND_REPORT_EMAIL]: !!merchantSettings?.sendReportEmail,
    [GoogleMerchantSettingsFormFields.DATA_SOURCE]: merchantSettings?.dataSource || undefined,
    [GoogleMerchantSettingsFormFields.DEFAULT_CATEGORY_ID]: merchantSettings?.defaultCategoryId || undefined,
    [GoogleMerchantSettingsFormFields.LANGUAGE]: merchantSettings?.language,
    [GoogleMerchantSettingsFormFields.FEED_LABEL]: merchantSettings?.feedLabel || undefined,
    [GoogleMerchantSettingsFormFields.CURRENCY]: merchantSettings?.currency,
    [GoogleMerchantSettingsFormFields.DRY_RUN]: merchantSettings?.dryRun,
  };
};
